module.exports = __webpack_public_path__ + "img/WechatIMG2.c4e276c0.png";